import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { SetupService } from './setup/setup.service';

@Injectable({ providedIn: 'root' })
export class SetupResolver implements Resolve<any> {
    constructor(private setupService: SetupService) {}

    resolve(): Observable<any> {
        // return false;
        return this.setupService.initialize();
    }
}
